import { Box, Stack } from "@mui/material";
import { GameTimelineHeader } from "../../Components/GameTimelinePost/Header/GameTimelineHeader";
import { HeaderContainer } from "../../Components/GameTimelinePost/Timeline/GameTimelineContainer.styles";
import React, { useEffect, useState } from "react";
import { NewEventsButton } from "../../Components/GameTimelinePost/Modal/NewEventsFab";
import { GameState } from "../../Components/GameTimelinePost/Header/GameState";
import { GameTimeline } from "../../Components/GameTimelinePost/Timeline/GameTimeline";
import { useInView } from "@infrastructure/Hooks/useInView";
import { TimelineData } from "../../Components/GameTimelinePost/Timeline/Types";
import { getGameTimelineDetails } from "../../Components/GameTimelinePost/Service";
import { PostsListFeedEntryComponent } from "../PostsFeed/PostsListFeedEntryComponent";
import { GeneralErrorsModal } from "../../Components/Modals/ServiceModals/GeneralErrorsModal/GeneralErrorsModal.component";

export function TimelinePage({
    gameId,
    params,
    userAvatar,
    userScreenName,
}: {
    gameId: string;
    params: URLSearchParams;
    userAvatar?: string;
    userScreenName?: string;
}) {
    const { ref: gameStateRef, inView } = useInView();
    const [timeline, setTimeline] = useState<TimelineData>();
    const scrollToTop = () => {
        document.body.scrollTo({ behavior: "smooth", top: 0 });
    };

    useEffect(() => {
        if (gameId) {
            getGameTimelineDetails(gameId).then(setTimeline);
        }
    }, [gameId]);

    if (!timeline) {
        return (
            <>
                <PostsListFeedEntryComponent
                    isDashboardFeed={false}
                    userScreenName={userScreenName}
                    userAvatar={userAvatar}
                    params={params}
                />
                <GeneralErrorsModal />
            </>
        );
    }

    return (
        <Stack
            style={{
                display: "flex",
                width: "100%",
                backgroundColor: "var(--community-color-snow-white)",
            }}
        >
            <HeaderContainer isTimelinePage={true}>
                <GameTimelineHeader timeline={timeline} />
            </HeaderContainer>
            <Stack>
                <NewEventsButton
                    timeline={timeline.timeline}
                    active={!inView}
                    onClick={scrollToTop}
                />
                <Box ref={gameStateRef}>
                    <GameState timeline={timeline} />
                </Box>
                <GameTimeline timeline={timeline.timeline} />
            </Stack>
        </Stack>
    );
}
